import getWindow from "./getWindow.js";
export default function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}


//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
// module id = 118
// module chunks = 0 1 2 3 5 6